import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Body } from '../Body/Body.esm.js';
import { Image } from '../Image/Image.esm.js';
import { aiLoaderStyles } from './AILoader.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * AI Loader component provides specialized loading indication for AI operations.
 * It consists of an image slot (for AI-related imagery) and loading text,
 * supporting both light and dark themes with full accessibility compliance.
 */
const AILoader = React__default.memo(React__default.forwardRef((_a, ref) => {
    var { inverse = false, imageSlot, message = "Loading...", className, "aria-busy": ariaBusy = true } = _a, props = __rest(_a, ["inverse", "imageSlot", "message", "className", "aria-busy"]);
    const { base, imageSlot: imageSlotClasses, textContent, } = aiLoaderStyles({
        inverse,
    });
    return (jsxs("div", Object.assign({ ref: ref, className: cn(base(), className), "aria-busy": ariaBusy, role: "status" }, props, { children: [imageSlot && (jsx("div", { "aria-hidden": "true", className: imageSlotClasses(), children: jsx(Image, { asChild: true, children: imageSlot }) })), jsx("div", { className: textContent(), children: jsx(Body, { size: "md", className: inverse
                        ? "iris:text-(--comp-color-content-ai-loader-label-inverse)"
                        : "iris:text-(--comp-color-content-ai-loader-label)", inverse: inverse, "aria-live": "polite", children: message }) })] })));
}));
AILoader.displayName = "AILoader";

export { AILoader };
